import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { MyPolicies } from '@views/interfaces';
@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private httpClient: HttpClient) {}

  async getModeloBase64() {
    const result = await firstValueFrom<ResponseCommonSI<string>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.DOWNLOAD_MODELO_BASE64}`)
    );
    return result.payload;
  }
  async myPolicyBase64(params: MyPolicies) {
    let queryParams = new HttpParams();
    for (const p in params) queryParams = queryParams.append(p, params[p]);
    const result = await firstValueFrom<ResponseCommonSI<string>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.DOWNLOAD_MY_POLICY_BASE64}`, {
        params: queryParams,
      })
    );
    return result.payload;
  }
}
